import { NavLink } from 'react-router-dom';
import { LayoutGrid, Table2, FileText, Upload } from 'lucide-react';
import { cn } from '@/lib/utils';

interface NavEntry {
  to: string;
  label: string;
  icon: typeof LayoutGrid;
  end?: boolean;
}

const NAV: NavEntry[] = [
  { to: '/', label: 'Map', icon: LayoutGrid, end: true },
  { to: '/table', label: 'Price List', icon: Table2 },
  { to: '/reports', label: 'Báo cáo', icon: FileText },
  { to: '/admin/import', label: 'Import', icon: Upload },
];

/**
 * Mobile-only bottom navigation. Shown < md (768px), hidden on tablet+ (sidebar takes over).
 * Fixed to viewport bottom; main content needs pb-20 to avoid being hidden behind it.
 */
export function BottomNav() {
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 flex h-16 border-t bg-card md:hidden print:hidden"
      role="navigation"
      aria-label="Mobile navigation"
    >
      {NAV.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            cn(
              'flex flex-1 flex-col items-center justify-center gap-0.5 text-[10px] font-medium transition-colors',
              isActive ? 'text-primary' : 'text-muted-foreground'
            )
          }
        >
          <item.icon className="h-5 w-5" strokeWidth={1.75} />
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
